
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Button, Card } from "react-bootstrap";
import { deleteProduct, searchProducts } from "../store/api/GetAllProduct";
import { EyeFill, EyeSlashFill, Search } from "react-bootstrap-icons";
import { setDialog } from "../store/api/Modals";
import { getSystemSettings } from "../store/api/SystemSettingsAPI";
import BihamtaTable from "../../Components/BihamtaTable";
import { useForm } from "react-hook-form";
import { isWebApp } from "../../store/api/CommonFunctions";
const SearchProduct = () => {

    const [showFilter, setShowFilter] = useState(true);
    const { register, handleSubmit } = useForm();
    const filterData = useSelector(state => state.ProductReducer.productSearchFilters);
    const settings = useSelector(state => state.SystemSettingsReducer.systemSettings);
    const settingNames = ['ProductGrouppingType', 'Product_ExtAttr1_Title', 'Product_ExtAttr2_Title'];
    const pgType = Array.isArray(settings ?? "") && settings.find(s => s.SettingName === "ProductGrouppingType") ?
        Number(settings.find(s => s.SettingName === "ProductGrouppingType").SettingValue) : 1;
    const dispatch = useDispatch();
    useEffect(() => {
        document.body.classList = "notMain";
        dispatch(getSystemSettings(settingNames));

    }, []);
    const search = (data) => {
        data.Skip = 0;
        data.Take = 10;
        dispatch(searchProducts(data));
    }
    const history = useHistory();
    const showProduct = (id) => {
        history.push("/BaseInfo/AddEditProduct/" + id);
    }

    const tableColes = [
        { colTitle: "کد کالا", colName: "KalaCode", justInMobile: true },
        { colTitle: "مارک کالا", colName: "HolderName", justInMobile: true, showCondition: () => pgType === 0 },
        { colTitle: (pgType === 1 ? "نام کالا" : "نوع کالا"), colName: "Name", justInMobile: true },
        { colTitle: "مدل کالا", colName: "Model", justInMobile: true },
        { colTitle: "آدرس در انبار", colName: "SecondName", justInMobile: false },
        { colTitle: "شرح کالا", colName: "Importer", justInMobile: false },
        { colTitle: "کارخانه سازنده", colName: "Manufacturer", justInMobile: false },
        { colTitle: settings?.find(s => s.SettingName === "Product_ExtAttr1_Title")?.SettingValue, colName: "ExtAttr1", justInMobile: false },
        { colTitle: settings?.find(s => s.SettingName === "Product_ExtAttr2_Title")?.SettingValue, colName: "ExtAttr2", justInMobile: false }
    ]
    const tableRowButtons = [
        {
            title: "حذف کالا", type: "delete", className: "group-Btn-smalll btn-danger", onclick: (item) => {
                dispatch(setDialog({
                    status: 'show',
                    arrayBtn: ['yes', 'no'],
                    dialogTitle: 'حذف کالا',
                    dialogText: 'آیا از حذف مطمئن هستید؟',
                    okOperation: deleteProduct(item.ID, search)
                }))
            }
        },
        {
            title: "نمایش کالا", type: "show", className: "group-Btn-smalll btn-success", onclick: (item) => showProduct(item.ID)
        }

    ]
    function showHideFilter(hide) {
        const divFilters = document.getElementById("divFilters");
        if (hide) {
            divFilters.classList.add("hiddenRow");
            setShowFilter(false);
        }
        else {
            divFilters.classList.remove("hiddenRow");
            setShowFilter(true);
        }
    }
    return (<div className="container-fluid mt-2" style={{ minHeight: '80vh' }}>
        <br />
        <Card>
            <Card.Header className="headerStyle">جستجوی کالاها</Card.Header>
            <Card.Body className="bodyStyle">
                <form onSubmit={handleSubmit(search)}>
                    <div className="row rowBorder" id="divFilters">
                        <div className="rowTitle">
                            فیلترهای جستجو
                            &nbsp;
                            {showFilter && <EyeSlashFill size={20} className="hoverIcon" style={{ cursor: "pointer", color: "#ca237e" }} onClick={() => showHideFilter(true)} />}
                            {!showFilter && <EyeFill size={20} className="hoverIcon" style={{ cursor: "pointer", color: "#ca237e" }} onClick={() => showHideFilter(false)} />}
                        </div>
                        <div className='form-group col-md-2'>
                            <input placeholder='کد کالا' type='text' className='form-control' name="Code" ref={register({})} defaultValue={filterData?.Code ?? ""}></input>
                        </div>
                        <div className='form-group col-md-2'>
                            <input placeholder='بارکد' type='text' className='form-control' name="BarCode" ref={register({})} defaultValue={filterData?.BarCode ?? ""}></input>
                        </div>
                        {pgType === 0 &&
                            <div className='form-group col-md-2'>
                                <input placeholder='مارک' type='text' className='form-control' name="HolderName" ref={register({})} defaultValue={filterData?.HolderName ?? ""}></input>
                            </div>
                        }
                        <div className="form-group col-md-2">
                            <input type='text' placeholder={pgType === 1 ? 'نام کالا' : "نوع کالا"} className="form-control" name="Name" ref={register({})} defaultValue={filterData?.Name ?? ""} />
                        </div>
                        <div className="form-group col-md-2">
                            <input type='text' placeholder='مدل کالا' className="form-control" name="Model" ref={register({})} defaultValue={filterData?.Model ?? ""} />
                        </div>
                        <div className="form-group col-md-2">
                            <select className="form-control" name="ProductOrPart" ref={register({})} defaultValue={filterData?.ProductOrPart ?? ""} >
                                <option value="">کالا قطعه است یا محصول؟</option>
                                <option value={false}>محصول</option>
                                <option value={true}>قطعه</option>
                            </select>
                        </div>
                        <div className="form-group col-md-2">
                            <input type='text' placeholder='آدرس در انبار' className="form-control" name="SecondName" ref={register({})} defaultValue={filterData?.SecondName ?? ""} />
                        </div>
                        <div className="form-group col-md-2">
                            <input type='text' placeholder='شرح کالا' className="form-control" name="Importer" ref={register({})} defaultValue={filterData?.Importer ?? ""} />
                        </div>
                        <div className="form-group col-md-2">
                            <input type='text' placeholder='کارخانه سازنده' className="form-control" name="Manufacturer" ref={register({})} defaultValue={filterData?.Manufacturer ?? ""} />
                        </div>
                        <div className="form-group col-md-2">
                            <input type='text' placeholder={settings?.find(s => s.SettingName === "Product_ExtAttr1_Title")?.SettingValue} className="form-control" name="ExtAttr1" ref={register({})} defaultValue={filterData?.ExtAttr1 ?? ""} />
                        </div>
                        <div className="form-group col-md-2">
                            <input type='text' placeholder={settings?.find(s => s.SettingName === "Product_ExtAttr2_Title")?.SettingValue} className="form-control" name="ExtAttr2" ref={register({})} defaultValue={filterData?.ExtAttr2 ?? ""} />
                        </div>
                    </div>
                    <div>
                        <Button className="mt-2 group-Btn" type="submit"><Search size={15} />&nbsp;جستجوی کالا</Button>
                    </div>
                </form>

                <BihamtaTable rowButtons={tableRowButtons} columns={tableColes} hasPaging={true} style={{ whiteSpace: isWebApp() ? "nowrap" : "normal" }} reducerName="ProductReducer" objectName="productListFull" searchMethod={(data) => dispatch(searchProducts(data))}
                    filterData={filterData} />
            </Card.Body>

        </Card>
    </div>
    );
}
export default SearchProduct;